import { useRbTexts } from 'remote-state/applicationHooks';

interface ComponentTexts {
  closedStatusTooltipText: string;
}

export default function useTexts(): ComponentTexts {
  const texts = useRbTexts();

  const componentTexts: ComponentTexts = {
    closedStatusTooltipText:
      texts?.['spaces.queue.tooltip.closedStatusDisabled'] ||
      'To close this service record, first open and resolve it.',
  };

  return componentTexts;
}
